<template>
  <div class="about">
    <h4>A site for events to better the world.</h4>
  </div>
</template>
